import React from 'react';
import DomeGallery from './components/DomeGallery';

function getGalleryImages() {
  if (Array.isArray(window.mofetDomeGalleryImages) && window.mofetDomeGalleryImages.length) {
    return window.mofetDomeGalleryImages;
  }

  const rootElement = document.getElementById('react-root');

  if (!rootElement || !rootElement.dataset.gallery) {
    return [];
  }

  try {
    return JSON.parse(rootElement.dataset.gallery) || [];
  } catch (error) {
    return [];
  }
}

function App() {
  const galleryImages = getGalleryImages();

  if (!galleryImages.length) {
    return null;
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <DomeGallery images={galleryImages} grayscale={false} />
    </div>
  );
}

export default App;
